import { editor } from 'monaco-editor'

export const DEFAULT_HEIGHT: number = 300

export const CODE_FIELD_COMMON_OPTIONS: editor.IStandaloneEditorConstructionOptions = {
  /*
  EditContext input ignores Cypress synthetic events in monaco >= 0.53
  https://github.com/microsoft/monaco-editor/issues/5059
  */
  editContext: false,
  minimap: { enabled: false },
  renderLineHighlightOnlyWhenFocus: true,
  scrollbar: { alwaysConsumeMouseWheel: false },
  scrollBeyondLastLine: false,
  stickyScroll: { enabled: false },
} as const
